// prettier-ignore
export const sexEnum = [
  { id: 'MAN', label: 'Muž' },
  { id: 'WOMAN', label: 'Žena' }
];
export const typeEnum = [{ id: 'NATURAL', label: 'fyzická osoba' }, { id: 'COMPANY', label: 'právnická osoba' }];

export const pcrPeopleType = [
  { id: 'NOT_KNOWN', label: 'neuvedeno' },
  { id: 'WANTED', label: 'hledaný' },
  { id: 'MISSING', label: 'pohřešovaný' }
];

export const pcrSearchResult = [
  { id: 'POZITIVNI', label: 'Pozitivní' },
  { id: 'NEGATIVNI', label: 'Negativní' },
  { id: 'ZAJMOVA', label: 'Zájmová' }
];

export const pcrPersonSearchResult = [
  { id: 'POZITIVNI_OSOBA', label: 'Pozitivní osoba' },
  { id: 'POZITIVNI_DOKLAD', label: 'Pozitivní doklad' },
  { id: 'POZITIVNI_OSOBA_DOKLAD', label: 'Pozitivní osoba i doklad' }
];

export const pcrPersonWarnings = [
  { id: 'OZBROJENY', label: 'Ozbrojený' },
  { id: 'NEBEZPECNY', label: 'Nebezpečný' },
  { id: 'NEBEZPECNY_OZBROJENY', label: 'Nebezpečný i ozbrojený' },
  { id: 'HROZI_UTEK', label: 'Hrozí útěk' },
  { id: 'DUSEVNI_NEMOC', label: 'Duševní nemoc' },
  { id: 'NEBEZPECNA_NEMOC', label: 'Nebezpečná nemoc' },
  { id: 'ZADNE', label: 'Žádné' }
];



// WEBPACK FOOTER //
// ./src/components/person/_personEnums.ts